import React from "react";

export default function CalculatorCard({ title, children }) {
  return (
    <div style={{
      background: "rgba(20,20,20,0.9)",
      backdropFilter: "blur(10px)",
      borderRadius: "16px",
      padding: "25px",
      boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
      border: "1px solid rgba(255,255,255,0.05)",
      marginBottom: "20px",
      color: "#fff"
    }}>
      <h2 style={{ marginBottom: "20px", color: "#ff4d00" }}>
        {title}
      </h2>

      {children}
    </div>
  );
}